// ABOUTME: Lets third-party widgets that expect the window to scroll the page work with Horizon's desktop scroller (.page-wrapper from 990px):
// re-dispatches the scroller's scroll events on window, so Videowise's home and PDP widgets, which load on a window scroll, see the page scroll;
// and applies Videowise's player scroll lock to the scroller as it applies to a window scroller. While its modal is open Videowise fixes the body
// (`.vm-modal--open body { inset: 0; position: fixed }`), which on a window scroller shows the page from its top until the modal closes and
// Videowise scrolls the window back, so the preview videos behind the modal leave the viewport and pause (live, and the build below 990px). On the
// desktop scroller that lock moves nothing, so the scroller goes to its top while the lock holds and back to where it was when it lifts.
// Theme code listens on the scroller itself (scroll-container.js), so it never receives the relayed events; on phones window scrolls natively.

const pageWrapper = document.querySelector('.page-wrapper');

if (pageWrapper) {
  pageWrapper.addEventListener('scroll', () => window.dispatchEvent(new Event('scroll')), { passive: true });

  let lockedAt = null;
  new MutationObserver(() => {
    const locked = document.documentElement.classList.contains('vm-modal--open');
    if (locked && lockedAt === null) {
      lockedAt = pageWrapper.scrollTop;
      if (lockedAt > 0) pageWrapper.scrollTo({ top: 0, behavior: 'instant' });
    } else if (!locked && lockedAt !== null) {
      if (lockedAt > 0) pageWrapper.scrollTo({ top: lockedAt, behavior: 'instant' });
      lockedAt = null;
    }
  }).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
}
